import React from "react";
import {
  Redirect,
  withRouter
} from "react-router-dom";
import { useParams } from "react-router-dom";
import { Waypoint } from "react-waypoint";
import AnimateEffect from "../../tool/animateEffect";
import { Navigator , MobileNav } from "./nav";
import { PrivacyPolicyContent } from "./privacyPolicyContent.js"
import { IndexFooter } from "./../index/indexFooter.js"
import { StringHelper, _} from "../../strings"
import  LanguageBar from '../LanguageBar';

class PrivacyPolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      landingWaypoint: false,
      navFix: true,
    };
    console.log("strings")
    console.log(StringHelper)
    console.log("lang: ", this.props.params?.lang_code);
    if (this.props.params?.lang_code) {
      StringHelper.setDefaultLoacle(this.props.params.lang_code);
    }
  }
  componentDidMount() {
    console.log("componentDidMount");
    setTimeout(function(){ window.scrollTo(0,0); }, 10);
    
    // Temporary fix: Auto-trigger waypoints to ensure components are visible
    setTimeout(() => {
      if (!this.state.landingWaypoint) {
        console.log("Auto-triggering landingWaypoint for privacy policy");
        this.setState({ landingWaypoint: true });
      }
    }, 500);
      // if (this.props.location !== prevProps.location) {

      // }
  }
  onLanguageChange(newLanguage) {
    console.log("newLanguage: ", newLanguage);
    window.location = '/' + newLanguage + '/privacy-policy';

    // this.forceUpdate();
  }


	render() {
    const {

      landingWaypoint,
      navFix
    } = this.state;
    return (
       <div className="main-container privacyPolicyPage">
        <Navigator onTop={navFix} />
        <MobileNav />
        <section className="section-1 vertical-flex-item">
          <Waypoint onEnter={()=>!landingWaypoint&&this.setState({landingWaypoint: true})} />
            <div className="landing-container">
              <AnimateEffect trigger={landingWaypoint} className={"title"} effect={"fadeIn"} delay={1000} >{_("privacy_policy_title")}</AnimateEffect>
            </div>
          <Waypoint onEnter={()=>!navFix&&this.setState({navFix: true})} />
        </section>
        <PrivacyPolicyContent />
        <Waypoint onEnter={()=>{navFix&&this.setState({navFix: false})}} />
        <section className="section-4 vertical-flex-item">
        </section>
        <IndexFooter />
        <LanguageBar onChange={(lang) => this.onLanguageChange(lang)}/>
      </div>
    );

  }
}

// Wrapper component to provide React Router v6 params to the class component
function PrivacyPolicyWrapper() {
  const params = useParams();
  return <PrivacyPolicy params={params} />;
}

export default PrivacyPolicyWrapper;
